module.exports = __webpack_public_path__ + "components/flag/static/square/ug-67d740301d95208e36ced69e89f2d70f.svg";